module.exports = __webpack_public_path__ + "img/mikoto_ASMR_TOP.06ce1dca.png";